import classnames from "classnames";
import styles from "@/styles/Steps.module.scss";
import IconStepsActive from "../svgs/icon_steps_active.svg";
import IconStepsPrev from "../svgs/icon_steps_prev.svg";

export default function Steps({ step, steps }) {
  const lastStep = steps.length;
  return (
    <div
      className={classnames(styles.steps, {
        [styles["steps--last"]]: step === lastStep,
      })}
    >
      {steps.map((value, i) => (
        <div
          key={`step-${i}`}
          className={classnames(styles.step, {
            [styles.prev]: step > i + 1,
            [styles.active]: step == i + 1,
            [styles.next]: step == i,
            [styles.first]: i == 0,
            [styles.between]: i > 0 && i + 1 < lastStep,
            [styles.last]: lastStep == i + 1,
          })}
        >
          <div className={styles.label}>{`STEP${i + 1}`}</div>
          <div className={styles.icon}>
            <span className={styles.activeIcon}><IconStepsActive /></span>
            <span className={styles.prevIcon}><IconStepsPrev /></span>
          </div>
          <div className={styles.caption}>{value}</div>
        </div>
      ))}
    </div>
  );
}
